import { ContentPagesEffects } from './content-pages.effect';

export const effects = [ContentPagesEffects];
export * from './content-pages.effect';
